export default "__VITE_ASSET__C5wNw$Sj__"